import { __rest } from 'tslib';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { SizeEnum } from '@teko/types/ds';
import { Body, styled } from '@teko/ds-desktop';
import { CheckOutlined } from '@teko/ds-icon';

const MAPPING_ICON_ACTIVE_SIZE = {
    [SizeEnum.xs]: 14,
    [SizeEnum.s]: 14,
};
const MAPPING_ACTIVE_BORDER = {
    [SizeEnum.xs]: '0px 24px 24px 0px',
    [SizeEnum.s]: '0px 24px 24px 0px',
};
const SelectionOption = (_a) => {
    var { children, block = true, isActive = false, onClick, iconActiveSize = SizeEnum.m, disabled = false } = _a, rest = __rest(_a, ["children", "block", "isActive", "onClick", "iconActiveSize", "disabled"]);
    const handleClick = () => {
        if (!disabled && typeof onClick === 'function') {
            onClick(!isActive);
        }
    };
    return (jsxs(Wrapper, Object.assign({ isActive: isActive, disabled: disabled, block: block, onClick: handleClick }, rest, { children: [disabled && jsx(OverlayDisabled, {}, void 0), typeof children === 'string' ? (jsx(Body, Object.assign({ style: { textAlign: 'center' }, level: 1 }, { children: children }), void 0)) : (children), !disabled && isActive && (jsxs(Fragment, { children: [jsx(ActiveBorder, { iconActiveSize: iconActiveSize }, void 0), jsx(Checked, { children: jsx(CheckOutlined, { size: MAPPING_ICON_ACTIVE_SIZE[iconActiveSize] || 20, color: "#ffffff" }, void 0) }, void 0)] }, void 0))] }), void 0));
};
const getBorderColor = (props) => {
    return props.isActive ? props.theme.colors.primary500 : '#e0e0e0';
};
const Wrapper = styled.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: #fff;
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
  ${props.block ? 'width: 100%;' : ''}

  &:hover {
    background: ${props.isActive || props.disabled ? '' : '#f3f3f3'} ;
  }
`);
const ActiveBorder = styled.div(({ iconActiveSize, theme }) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${MAPPING_ACTIVE_BORDER[iconActiveSize] || '0px 36px 36px 0px'};
  border-color: transparent ${theme.colors.primary500} transparent transparent;
`);
const Checked = styled.span `
  display: flex;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 0;
`;
const OverlayDisabled = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;

export { SelectionOption as S };
